// Shared controls. Keep visual variants in styles/components.css.

import React from 'react';
import './Button.css';

// PrimaryButton Component
const PrimaryButton = ({ children, className = '', type = 'button', ...props }) => {
    return (
        <button type={type} className={`ui-button ui-button--primary ${className}`} {...props}>
            {children}
        </button>
    );
};

// SecondaryButton Component
const SecondaryButton = ({ children, className = '', type = 'button', ...props }) => {
    return (
        <button type={type} className={`ui-button ${className}`} {...props}>
            {children}
        </button>
    );
};

// IconButton Component
const IconButton = React.forwardRef(({ icon, children, className = '', type = 'button', ...props }, ref) => {
    return (
        <button ref={ref} type={type} className={`ui-button ui-button--ghost ui-button--icon ${className}`} {...props}>
            {icon || children}
        </button>
    );
});
IconButton.displayName = 'IconButton';

// SubmitButton Component
const SubmitButton = ({ children, className = '', ...props }) => {
    return (
        <button className={`ui-button ui-button--primary ${className}`} type="submit" {...props}>
            {children}
        </button>
    );
};

// CancelButton Component
const CancelButton = ({ children, className = '', type = 'button', ...props }) => {
    return (
        <button type={type} className={`ui-button ${className}`} {...props}>
            {children}
        </button>
    );
};

export { PrimaryButton, SecondaryButton, IconButton, SubmitButton, CancelButton };
